export default __webpack_public_path__ + "static/media/vuesion.4e6de9c1.webp";